<div class="subscribe-container" [style.backgroundColor]="backgroundColor">
    <div class="text-container">
        <h2>Votre liste est vide</h2>
    </div>
    <div class="text-container">
       <p class="primary-text">Pour <b>ajouter des ressources à votre liste</b>, il vous suffit de cliquer sur le marque-page en haut à droite des sujets qui vous intéressent.</p>
    </div>
    <div>
        <img class="subscribe-image" src="assets/images/book-lover.png" alt="Liste vide">
    </div>
</div>